// Where to review the records that block a project's deletion. Only tables that have a page are linked; the rest are
// still listed with their counts.
const GLOBAL = {
  purchase_indents: "purchase-indents", purchase_requisitions: "purchase-requisitions", rfqs: "rfqs", purchase_orders: "purchase-orders",
  work_orders: "work-orders", service_requisitions: "service-requisitions", goods_issues: "goods-issues",
  warehouses: "warehouses",
};
const PROJECT = { daily_reports: "daily-reports", issues: "issues", project_documents: "documents", site_expenses: "site-expenses", delays: "delays" };

export function linkedRecordsPath(table, projectId) {
  if (PROJECT[table]) return `/projects/${projectId}/${PROJECT[table]}`;
  if (GLOBAL[table]) return `/erp/operations/${GLOBAL[table]}`;
  return null;
}
